module dg.loading {
    function dgDataLoader($filter, $timeout, $parse, dataLoaderService: dg.loading.DataLoaderService): ng.IDirective {
        return {
            restrict: 'A',
            scope: {
            },
            templateUrl: '/digmo/src/loading/dg-data-loader.html',
            controller: ($scope, $element) => {
                $scope.loadingInfo = dataLoaderService.loadingInfo;
                $scope.loadingFinished = false;

                let currentLoaderLevel = $($element).parents(".dg-view").length;

                let watchListener = $scope.$watch("loadingInfo.inProgress", (inProgress, oldInProgress) => {
                    if (inProgress != oldInProgress) {
                        if ($scope.loadingInfo.inProgress) {
                            $scope.loadingFinished = false;
                        } else {

                        }
                    }
                });

                $scope.$watch("loadingInfo.currentLoadingLevel", () => {
                    if(currentLoaderLevel < $scope.loadingInfo.currentLoadingLevel) {
                        $scope.loadingFinished = true;
                    }

                    //$scope.loadingFinished = currentLoaderLevel < $scope.loadingInfo.currentLoadingLevel;
                });
            }
        };
    }

    angular.module('dg.loading')
        .directive('dgDataLoader', dgDataLoader);
}
